import { Injectable } from '@angular/core';

import { LocalStorageKeys } from '../enums';
import { RedirectQueryParams } from '../models/redirect-query-params';

@Injectable({
  providedIn: 'root',
})
export class RedirectLoaderService {
  private privateRedirectQueryParams: RedirectQueryParams;

  set redirectQueryParams(val: RedirectQueryParams) {
    this.privateRedirectQueryParams = val;
  }

  get redirectQueryParams(): RedirectQueryParams {
    return this.privateRedirectQueryParams;
  }

  setInLocalStorage(queryParams: RedirectQueryParams): void {
    if (!localStorage.getItem(LocalStorageKeys.SIGNATURE)) {
      localStorage.setItem(LocalStorageKeys.SIGNATURE, queryParams.signature);
    }
    if (!localStorage.getItem(LocalStorageKeys.URL))
      localStorage.setItem(LocalStorageKeys.URL, queryParams.url);
    if (!localStorage.getItem(LocalStorageKeys.LANGUAGE)) {
      localStorage.setItem(LocalStorageKeys.LANGUAGE, queryParams.language);
    }
  }

  getLocalStorageQueryParams(): RedirectQueryParams {
    return {
      kip: JSON.parse(localStorage.getItem(LocalStorageKeys.KIP)).kip,
      signature: localStorage.getItem(LocalStorageKeys.SIGNATURE),
      url: localStorage.getItem(LocalStorageKeys.URL),
      language: localStorage.getItem(LocalStorageKeys.LANGUAGE),
    };
  }

  removeFromLocalStorage(): void {
    localStorage.removeItem(LocalStorageKeys.KIP);
    // localStorage.removeItem(LocalStorageKeys.LANGUAGE);
    localStorage.removeItem(LocalStorageKeys.INSTALLMENTS);
    localStorage.removeItem(LocalStorageKeys.SIGNATURE);
    localStorage.removeItem(LocalStorageKeys.URL);
    // localStorage.removeItem('url');
  }
}
